import { useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router";
import { BottomTab } from "./bottom-tab";

const scrollPositions = new Map<string, number>();

export function AppLayout() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const prevPathnameRef = useRef(pathname);

  // Continuously track scroll position for current pathname
  useEffect(() => {
    const handleScroll = () => {
      scrollPositions.set(pathname, window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      handleScroll();
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname]);

  // Restore saved scroll position or reset to top on route change
  useEffect(() => {
    if (prevPathnameRef.current === pathname) return;
    prevPathnameRef.current = pathname;

    const savedPosition = scrollPositions.get(pathname);
    if (savedPosition != null) {
      requestAnimationFrame(() => {
        window.scrollTo(0, savedPosition);
      });
    } else if (navigationType !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return (
    <div className="flex min-h-dvh flex-col overflow-x-clip">
      <main className="flex flex-1 flex-col">
        <Outlet />
      </main>
      <BottomTab />
    </div>
  );
}
